import { strategyToOptions } from "../utils/strategyToOptions";

export const equipmentStatusTranslation = {
  enabled: 'Ativo',
  disabled: 'Inativo',
  blocked: 'Bloqueado',
  awaiting_card: 'Aguardando cartão'
};

export const equipmentStatusOptions = strategyToOptions(equipmentStatusTranslation)